import { client } from "@/shared/api/client";
import { unwrap, type Envelope } from "@/shared/api/envelope";
import type { OnboardingState } from "@/shared/types";

import type { OnboardingData } from "../types";

/** Save wizard progress. `step` is the index to resume at, so it is the step
    just finished plus one; `data` replaces what was stored, wholesale. */
export async function putOnboarding(body: {
  step: number;
  data: OnboardingData;
  completed?: boolean;
}): Promise<OnboardingState> {
  return unwrap(await client.put<Envelope<OnboardingState>>("/settings/onboarding", body));
}
